import { Link } from "react-router-dom";

interface ICardButtonProps {
  route: string;
  icon: string;
  title: string;
  tooltip: string;
  data?: object;
  dataTestid: string;
}

const CardButton = (cardButtonProps: ICardButtonProps) => {
  var icon = "fi " + cardButtonProps.icon;

  return (
    <div className="card bg-grey icon-card">
      <Link
        to={cardButtonProps.route}
        className="card-inner-wrap"
        data-testid={"Link" + cardButtonProps.dataTestid}
        state={{ data: cardButtonProps.data }}
      >
        <div className="card-info">
          <i className={icon} />
          <span
            className="card-title"
            data-testid={"Title" + cardButtonProps.dataTestid}
          >
            {cardButtonProps.title}
          </span>
        </div>
        <div
          className="card-tooltip"
          data-testid={"Tooltip" + cardButtonProps.dataTestid}
        >
          {cardButtonProps.tooltip}
        </div>
        <span className="fi fi-rr-arrow-small-right arrow-icon" />
      </Link>
    </div>
  );
};

export default CardButton;
